import { getAuthAxiosBackend } from "@/helpers/axios"

class ResidenceDataServices{

    get(id){
        return getAuthAxiosBackend().get('residenceData/getResidenceData/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('ResidenceData/getResidenceDataByPersonId/' + personId.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('residenceData/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('residenceData/addResidenceData', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('ResidenceData/updateResidenceData/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('residenceData/softDeleteResidenceData/' + id.toString())
    }
}

export default new ResidenceDataServices()